module.exports = __webpack_public_path__ + "static/media/mems.7e5a7c0d.gif";